module.exports = __webpack_public_path__ + "static/media/bl_edit.e8038b38.svg";